import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import PricingSection from "../components/PricingSection";
import GallerySection from "../components/GallerySection";

export default function MobilhazakPage() {
  return (
    <div className="bg-black text-white min-h-screen">
      
      {/* Hero */}
      <section className="relative py-16 md:py-24 bg-gradient-to-b from-black via-[#0a0a0a] to-[#111]">
        <div className="max-w-5xl mx-auto px-4 text-center">
          {/* Badge */}
          <div className="mb-6">
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-green-500/20 border border-green-500/40 rounded-full text-white text-sm font-medium">
              <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
              Azonnal elérhetők
            </span>
          </div>
          
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black mb-4">
            Mobilházak
          </h1>
          <p className="text-xl md:text-2xl text-secondary font-semibold mb-6">
            Gyors megoldás. Fix ár. Rövid döntési út.
          </p>
          <p className="text-gray-400 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed mb-8">
            Kulcsrakész prémium mobilházak raktárról – azonnal, megbízhatóan, 
            akár teljes felszereltséggel és további extrákkal.
          </p>
          
          {/* Price highlight */}
          <div className="inline-flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-6 py-4 mb-8">
            <span className="text-3xl md:text-4xl font-black text-white">370.000</span>
            <div className="text-left">
              <span className="block text-yellow-400 font-bold">Ft / nettó m²</span>
              <span className="block text-gray-500 text-sm">kulcsrakészen</span>
            </div>
          </div>
          
          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/kapcsolat"
              className="bg-secondary hover:bg-hover text-white font-bold px-8 py-4 rounded-xl transition-all"
            >
              🏠 Ingyenes ajánlatkérés
            </Link>
            <a
              href="#tipusok"
              className="bg-white/10 hover:bg-white/20 text-white font-bold px-8 py-4 rounded-xl border border-white/[0.08] transition-all"
            >
              📋 Típusok megtekintése
            </a>
          </div>
        </div>
      </section>

      {/* Key Benefits */}
      <section className="py-12 md:py-16 bg-[#0a0a0a]">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-[#1a1a1a] rounded-xl p-6 border border-white/5 text-center">
              <span className="text-4xl mb-4 block">⏱️</span>
              <h3 className="text-white font-bold text-lg mb-2">Gyors kivitelezés</h3>
              <p className="text-gray-400 text-sm">Rövid időn belül beköltözhetsz új otthonodba</p>
            </div>
            <div className="bg-[#1a1a1a] rounded-xl p-6 border border-white/5 text-center">
              <span className="text-4xl mb-4 block">💰</span>
              <h3 className="text-white font-bold text-lg mb-2">Fix ár</h3>
              <p className="text-gray-400 text-sm">Nincs rejtett költség, átlátható árképzés</p>
            </div>
            <div className="bg-[#1a1a1a] rounded-xl p-6 border border-white/5 text-center">
              <span className="text-4xl mb-4 block">🔑</span>
              <h3 className="text-white font-bold text-lg mb-2">Kulcsrakész</h3>
              <p className="text-gray-400 text-sm">Komplett, beköltözhető állapotban</p>
            </div>
          </div>
        </div>
      </section>

      {/* Types Section */}
      <div id="tipusok">
        <PricingSection />
      </div>
      
      {/* Gallery */}
      <GallerySection />

      {/* Why Mobilház */}
      <section className="py-12 md:py-20 bg-[#111]">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
            Miért mobilház?
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <span className="text-green-400 text-xl">✓</span>
                <div>
                  <h3 className="text-white font-semibold">Nincs építési engedély</h3>
                  <p className="text-gray-400 text-sm">Egyszerűsített ügyintézés</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-green-400 text-xl">✓</span>
                <div>
                  <h3 className="text-white font-semibold">Áthelyezhető</h3>
                  <p className="text-gray-400 text-sm">Ha költöznél, viheted magaddal</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-green-400 text-xl">✓</span>
                <div>
                  <h3 className="text-white font-semibold">Energiahatékony</h3>
                  <p className="text-gray-400 text-sm">Alacsony rezsiköltség</p>
                </div>
              </div>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <span className="text-green-400 text-xl">✓</span>
                <div>
                  <h3 className="text-white font-semibold">Modern dizájn</h3>
                  <p className="text-gray-400 text-sm">Letisztult, skandináv stílus</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-green-400 text-xl">✓</span>
                <div>
                  <h3 className="text-white font-semibold">Személyre szabható</h3>
                  <p className="text-gray-400 text-sm">Válassz extrák közül</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-green-400 text-xl">✓</span>
                <div>
                  <h3 className="text-white font-semibold">Garancia</h3>
                  <p className="text-gray-400 text-sm">Teljes körű garanciával</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-[#0a0a0a] to-black">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-4xl font-bold mb-4">
            Érdekel a mobilház megoldás?
          </h2>
          <p className="text-gray-400 mb-8">
            Kérj ingyenes ajánlatot, és megbeszéljük a részleteket.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/kapcsolat"
              className="bg-secondary hover:bg-hover text-white font-bold px-8 py-4 rounded-xl transition-all"
            >
              Ajánlatkérés
            </Link>
            <Link
              to="/"
              className="bg-white/10 hover:bg-white/20 text-white font-bold px-8 py-4 rounded-xl border border-white/[0.08] transition-all"
            >
              Vissza a főoldalra
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
